export function createBlock(blockId) {
    const $block = $('<div></div>');
    $block.append(`<div id="yandex_rtb_${blockId}"></div>`);
    $block.append(`<script type="text/javascript">
        (function(w, d, n, s, t) {
            w[n] = w[n] || [];
            w[n].push(function() {
                Ya.Context.AdvManager.render({
                    blockId: "${blockId}",
                    renderTo: "yandex_rtb_${blockId}",
                    async: true
                });
            });
            t = d.getElementsByTagName("script")[0];
            s = d.createElement("script");
            s.type = "text/javascript";
            s.src = "//an.yandex.ru/system/context.js";
            s.async = true;
            t.parentNode.insertBefore(s, t);
        })(this, this.document, "yandexContextAsyncCallbacks");
    </script>`);
    return $block;
}